import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Input, Radio, Modal, message, Button } from 'hljd'
import Upload from '../../Upload'
import { observer } from 'mobx-react'
import {
  CONTACT_MOBILE,
  CONTACT_ARRI,
  CONTACT_WECAHT,
  CONTACT_PRIVATE_CHAT,
  CONTACT_OTHER
} from '@components/JiaMeng/NewCustomer/constant'
import Chat from '@common/Chat'
import style from '@components/JiaMeng/NewCustomer/style/modal.css'

const FormItem = Form.Item
const { TextArea } = Input

@Form.create()
@observer
class CommunicateModal extends Component {
  handleOk = () => {
    const { store, form } = this.props
    const { createContact } = store
    const fieldValue = form.getFieldsValue()

    if (!fieldValue.contact_way) {
      return message.warning('请选择跟进方式')
    }
    if (!fieldValue.remark) {
      return message.warning('请输入跟进信息')
    }

    const value = {
      ...fieldValue,
      attachments: JSON.stringify(fieldValue.attachments)
    }

    createContact(value)
  }

  changeRadio = e => {
    const { value } = e.target
    this.props.store.setStoreData([{ type: 'contactType', value }])
  }

  render() {
    const {
      form: { getFieldDecorator },
      store
    } = this.props
    const {
      contactModalVisible,
      openOrCloseContactModal,
      detailData,
      contactType,
      customerName
    } = store
    const { user_phone, channel_id, user_id } = detailData

    return (
      <Modal
        title="沟通记录"
        visible={contactModalVisible}
        onOk={this.handleOk}
        onCancel={() => openOrCloseContactModal(false)}
        destroyOnClose={true}
        width={480}
        wrapClassName={style.modal}
      >
        <Form className={style.form}>
          <FormItem label="跟进方式">
            {getFieldDecorator('contact_way', {
              initialValue: contactType
            })(
              <Radio.Group onChange={this.changeRadio}>
                <Radio value={CONTACT_ARRI}>到店</Radio>
                <Radio value={CONTACT_MOBILE}>电话</Radio>
                <Radio value={CONTACT_WECAHT}>微信</Radio>
                <Radio value={CONTACT_PRIVATE_CHAT}>私信</Radio>
                <Radio value={CONTACT_OTHER}>其他</Radio>
              </Radio.Group>
            )}
          </FormItem>

          {contactType == CONTACT_PRIVATE_CHAT && (
            <FormItem label="用户名">
              <span style={{ marginRight: 20 }}>{customerName}</span>

              {channel_id > 0 && (
                <Chat toUserId={user_id}>
                  <Button type="primary">私信</Button>
                </Chat>
              )}
            </FormItem>
          )}

          {contactType == CONTACT_MOBILE && (
            <FormItem label="电话">{user_phone || '无'}</FormItem>
          )}

          {getFieldDecorator('remark')(
            <TextArea rows={3} placeholder="记录本次跟进信息" />
          )}

          <div>
            {getFieldDecorator('attachments', {
              initialValue: []
            })(<Upload />)}
          </div>
        </Form>
      </Modal>
    )
  }
}

export default CommunicateModal
